module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/streams.dynamodb-2012-08-10.paginators.json
// module id = 796
// module chunks = 1